import React from "react";
import { Tab, Nav } from "react-bootstrap";
import { EditableTable } from "../../Components/EditableTable/EditableTable";

export class TabsVersiones extends React.Component {
  render() {
    const { versiones } = this.props;

    return (
      <Tab.Container id="tabs-versiones" defaultActiveKey={"version-1"}>
        <Nav variant="tabs">
          {versiones && versiones.map((version, index) => (
            <Nav.Item key={index}>
              <Nav.Link eventKey={`version-${version.numeroVersion}`}>
                {`Versión ${version.numeroVersion}`}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        <Tab.Content>
          {versiones && versiones.map((version, index) => (
            <Tab.Pane key={index} eventKey={`version-${version.numeroVersion}`}>
              <EditableTable versionTabla={version} />
            </Tab.Pane>
          ))}
        </Tab.Content>
      </Tab.Container>
    );
  }
}
